import Jobs from '@furnish-hx/constants/Jobs';
import { IJobs } from '../interfaces/IJobs';
import objectEntriesTyped from '../utils/objectEntriesTyped';
import ServiceStructure from './ServiceStructure';

const JobsStructure: Readonly<IJobs> = (
    Object.fromEntries(
        objectEntriesTyped(Jobs)
            .map(([jobId, serviceIds]) => [
                jobId,
                Object.fromEntries(serviceIds.map((serviceId) => [serviceId, ServiceStructure[serviceId]])),
            ]),
    )
) as IJobs;

export const ARBORESCENCE_VERSION = 42;

export default JobsStructure;
